module.exports = "<div class=\"error-division\" *ngIf=\"msg\">\r\n    <p class=\"error text-right text-small\">\r\n        {{msg}}\r\n    </p>\r\n</div>"